import React from "react";
import FieldProto from "../../../../proto/field-proto";
import {PopoverParent} from "../../../../@types";
import ModelEntity from "../../../../../model2/model-entity";
import {QuickAddItemType} from "../../../../../../app/quick-add/@types";

const debug = false
// const debug = "FieldDropdown_PopoverMenuMore"

export type PopoverMenuMoreProps = {
    parent  : PopoverParent //
    field   : FieldProto
    model?  : ModelEntity
}

export default class FieldTags_PopoverMenuMore extends React.Component<PopoverMenuMoreProps> {

    // static propTypes = {
    //     parent: PropTypes.object,
    //     field: PropTypes.object
    // }

    onClick = ()=>{
        this.props.parent.hidePopover();
        gd.openNew(QuickAddItemType.TAG, {
            // callback: this.onTagAdd
        });
    }

    render() {
        return (
            <div className="flex-row-left-center h-36 p-h-15" onClick={this.onClick}>
                <div className="ui5-ico-12 i5-plus action flex-no-shrink m-r-15"/>
                <div className="ui5-txt-no-accent-default">New tag</div>
            </div>
        )
    }
}